<div class="order-details">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        {{ 'FRONTEND.SALES_UI.ORDER_DETAILS.TITLE' | translate }}
      </mat-card-title>
      <mat-card-subtitle *ngIf="!hasError && !isCustomerDetails">
        {{ 'FRONTEND.SALES_UI.ORDER_DETAILS.SUBTITLE' | translate }}
        <span *ngIf="getOrderSubmitterName() as nameOfSubmitter">
          {{ 'FRONTEND.SALES_UI.ORDER_DETAILS.CREATED_BY' | translate: { name: nameOfSubmitter } }}
        </span>
        <ng-container *ngIf="getOrderSubmitterBadgeInfo() as badgeInfo">
          <glxy-badge color="{{ badgeInfo.color }}">
            {{ badgeInfo.tranlationKey | translate }}
          </glxy-badge>
        </ng-container>
      </mat-card-subtitle>
      <div class="spacer"></div>
      <div class="object-id">{{ order.orderId }}</div>
    </mat-card-header>

    <mat-card-content *ngIf="!hasError; else orderErrorMsg">
      <div class="order-details-content" *ngIf="orderDetails && !isLoading; else loadingOrder">
        <ng-container *ngIf="salesperson">
          <div class="order-details__list-item">
            <div class="detail-left-col">Salesperson</div>
            <div class="order-details__list-item__value">{{ salesperson.firstName }} {{ salesperson.lastName }}</div>
          </div>
        </ng-container>
        <ng-container *ngIf="offerExpiryDisplay">
          <div class="order-details__list-item">
            <div class="detail-left-col">
              {{ 'FRONTEND.SALES_UI.OFFER_EXPIRY' | translate }}
            </div>
            <div class="order-details__list-item__value">
              {{ offerExpiryDisplay }}
            </div>
          </div>
        </ng-container>

        <sales-ui-sales-order-details-requested-activation
          [order]="order"
          [editable]="editable"
        ></sales-ui-sales-order-details-requested-activation>

        <sales-ui-sales-order-details-contract-duration
          [order]="order"
          [editable]="!isCustomerDetails && orderDetailsEditable"
        ></sales-ui-sales-order-details-contract-duration>

        <ng-container *ngFor="let info of orderDetails">
          <ng-container
            *ngTemplateOutlet="info.childFields.length ? multiStep : singleStep; context: { info: info }"
          ></ng-container>
          <ng-template #multiStep let-info="info">
            <mat-accordion [multi]="true">
              <mat-expansion-panel class="no-styling">
                <mat-expansion-panel-header [collapsedHeight]="'56px'" [expandedHeight]="'auto'">
                  <ng-container *ngTemplateOutlet="singleStep; context: { info: info }"></ng-container>
                </mat-expansion-panel-header>
                <mat-divider></mat-divider>
                <ng-container *ngFor="let child of info.childFields">
                  <ng-container
                    *ngTemplateOutlet="singleStep; context: { info: child, isChild: true, compact: true }"
                  ></ng-container>
                  <mat-divider></mat-divider>
                </ng-container>
              </mat-expansion-panel>
            </mat-accordion>
          </ng-template>
          <ng-template #singleStep let-info="info" let-isChild="isChild" let-compact="compact">
            <div class="order-details__list-item row" [ngClass]="{ compact: compact }">
              <div class="detail-left-col">
                {{ buildDetailName(info, isChild) | translate }}
              </div>
              <div class="order-details__list-item__value show-line-breaks">
                {{ buildDetailValue(info) }}
              </div>
            </div>
          </ng-template>
          <mat-divider></mat-divider>
        </ng-container>

        <div *ngIf="declinedReason">
          <div class="dynamic-item-container dynamic-list-item">
            <div class="detail-left-col">
              {{ 'FRONTEND.SALES_UI.REASON_FOR_DECLINE' | translate }}
            </div>
            <div class="order-details__list-item__value">
              {{ declinedReason }}
            </div>
          </div>
          <mat-divider class="dynamic-list-item-divider"></mat-divider>
        </div>

        <div *ngIf="!isCustomerDetails && orderDetailsEditable">
          <div class="order-details__list-item">
            <div class="detail-left-col">
              {{ 'FRONTEND.SALES_UI.ATTACHMENTS' | translate }}
            </div>

            <ng-container *ngIf="(isEditing$$ | async) === true; else display">
              <div class="attachments">
                <div class="attachments-container">
                  <glxy-uploader
                    #filesUploader
                    [autoUpload]="true"
                    [uploadUrl]="attachmentsUploadUrl"
                    [maxFiles]="100"
                    [files]="files"
                    (fileUploadErrored)="handleFileUploadError($event)"
                    (filesChanged)="updateFilesUploaded($event)"
                  ></glxy-uploader>
                  <div class="order-details__list-item__value" *ngIf="files">
                    <glxy-uploader-list
                      [files]="files"
                      (fileDeleted)="filesUploader.deleteFile($event)"
                    ></glxy-uploader-list>
                  </div>
                </div>
                <button
                  class="button--save-attachments"
                  mat-flat-button
                  color="primary"
                  (click)="updateAttachmentsOnOrder()"
                >
                  {{ 'FRONTEND.SALES_UI.SAVE' | translate }}
                </button>
              </div>
            </ng-container>

            <ng-template #display>
              <div class="order-details__list-item__value">
                <div class="item-container">
                  <glxy-uploader-list *ngIf="files" [files]="files"></glxy-uploader-list>
                  <button mat-icon-button (click)="edit()">
                    <mat-icon>edit</mat-icon>
                  </button>
                </div>
              </div>
            </ng-template>
          </div>
          <mat-divider class="dynamic-list-item-divider"></mat-divider>
        </div>

        <div *ngIf="agreements && agreements.length > 0">
          <div class="dynamic-item-container dynamic-list-item">
            <div class="detail-left-col">
              {{ 'FRONTEND.SALES_UI.CUSTOMER_AGREEMENTS' | translate }}
            </div>
            <div class="order-details__list-item__value">
              <div>{{ buildCustomerApprovalNameAndDate() }}</div>
              <div *ngFor="let agreement of agreements; last as isLast" class="agreements">
                <div class="agreement-container">
                  <div class="checkbox-container">
                    @if (agreement.agreed) {
                      <mat-icon class="agreement-accepted">check_circle_outline</mat-icon>
                    } @else {
                      <mat-icon class="agreement-not-accepted">highlight_off</mat-icon>
                    }
                  </div>
                  <div class="agreement-content">
                    <div>
                      <span [innerHTML]="agreement.term"></span>
                    </div>
                    <div class="agreement-submitted-by" *ngIf="agreement.name">
                      <b>Submitted By:</b>
                      {{ agreement.name }}
                    </div>
                  </div>
                </div>
                <div class="agreements-divider">
                  <mat-divider *ngIf="!isLast"></mat-divider>
                </div>
              </div>
            </div>
          </div>
          <mat-divider class="dynamic-list-item-divider"></mat-divider>
        </div>

        <sales-ui-sales-order-details-customer-notes
          *ngIf="order.customerNotes || !isCustomerDetails"
          [order]="order"
          [isCustomerDetails]="isCustomerDetails"
          [editable]="!isCustomerDetails && orderDetailsEditable"
        ></sales-ui-sales-order-details-customer-notes>
        <ng-container *ngIf="!isCustomerDetails">
          <sales-ui-sales-order-details-notes
            [order]="order"
            [editable]="orderDetailsEditable"
          ></sales-ui-sales-order-details-notes>

          <sales-ui-sales-order-details-tags
            [tags]="order.tags"
            [orderId]="order.orderId"
            [businessId]="order.businessId"
            [partnerId]="order.partnerId"
            [marketId]="order.marketId"
            [editable]="!isCustomerDetails && orderDetailsEditable"
          ></sales-ui-sales-order-details-tags>
        </ng-container>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<!-- templates -->
<ng-template #orderErrorMsg>
  <div class="error-message">
    <uikit-empty-state iconName="error">
      <span state-description>
        {{ 'FRONTEND.SALES_UI.ORDER_DETAILS.ORDER_INFO_ERROR' | translate }}
      </span>
    </uikit-empty-state>
  </div>
</ng-template>

<ng-template #loadingOrder>
  <div class="loading-indicator">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
</ng-template>
